import { getConsentInitializationSnippet, getDataLayerSnippet, getGTMScript, getIframeSnippet } from './snippets';

var setupGTM = function setupGTM(params) {
  var getConsentInitializationScript = function getConsentInitializationScript() {
    var consentInitializationScript = document.createElement('script');
    consentInitializationScript.innerHTML = getConsentInitializationSnippet(params.dataLayerName);
    return consentInitializationScript;
  };

  var getDataLayerScript = function getDataLayerScript() {
    var dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = getDataLayerSnippet(params.dataLayer, params.dataLayerName);
    return dataLayerScript;
  };

  var getNoScript = function getNoScript() {
    var noScript = document.createElement('noscript');
    noScript.innerHTML = getIframeSnippet(params.id, params.environment);
    return noScript;
  };

  var getScript = function getScript() {
    var script = document.createElement('script');

    if (params.nonce) {
      script.setAttribute('nonce', params.nonce);
    }

    script.innerHTML = getGTMScript(params.dataLayerName, params.id, params.environment);
    return script;
  };

  return {
    getConsentInitializationScript: getConsentInitializationScript,
    getDataLayerScript: getDataLayerScript,
    getNoScript: getNoScript,
    getScript: getScript
  };
};

export var initGtm = function initGtm(_ref) {
  var dataLayer = _ref.dataLayer,
      dataLayerName = _ref.dataLayerName,
      environment = _ref.environment,
      nonce = _ref.nonce,
      id = _ref.id;
  var gtm = setupGTM({
    dataLayer: dataLayer,
    dataLayerName: dataLayerName,
    environment: environment,
    nonce: nonce,
    id: id
  });
  var consentInitializationScript = gtm.getConsentInitializationScript();
  var dataLayerScript = gtm.getDataLayerScript();
  var script = gtm.getScript();
  var noScript = gtm.getNoScript();
  document.head.insertBefore(consentInitializationScript, document.head.childNodes[0]);
  document.head.insertBefore(dataLayerScript, document.head.childNodes[1]);
  document.head.insertBefore(script, document.head.childNodes[2]);
  document.body.insertBefore(noScript, document.body.childNodes[0]);
};
export var sendToGTM = function sendToGTM(_ref2) {
  var dataLayerName = _ref2.dataLayerName,
      data = _ref2.data;

  if (window[dataLayerName]) {
    window[dataLayerName].push(data);
  } else {
    console.warn("dataLayer ".concat(dataLayerName, " does not exist, GTM script has to be initialized"));
  }
};